import { LoginOutlined, MailOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Result, Typography } from 'antd';
import { useEffect, useState } from 'react';

export default function ActivationEmailSentStep({ email, onBack, onResend, onSignIn }) {
  const [resendCooldown, setResendCooldown] = useState(0);

  useEffect(() => {
    if (resendCooldown <= 0) return undefined;
    const timerId = window.setTimeout(() => setResendCooldown((seconds) => seconds - 1), 1000);
    return () => window.clearTimeout(timerId);
  }, [resendCooldown]);

  const resend = () => {
    onResend?.();
    setResendCooldown(60);
  };

  return (
    <section className="onboarding-activation">
      <Result
        status="info"
        icon={<MailOutlined />}
        title="Check your email"
        subTitle={<>We prepared an activation link for <strong>{email}</strong>.</>}
        extra={[
          <Button key="resend" type="primary" icon={<ReloadOutlined />} disabled={resendCooldown > 0} onClick={resend}>
            {resendCooldown > 0 ? `Resend in ${resendCooldown}s` : 'Resend activation link'}
          </Button>,
          <Button key="back" onClick={onBack}>Change email</Button>,
          <Button key="signin" icon={<LoginOutlined />} onClick={onSignIn}>Back to sign in</Button>,
        ]}
      />
      <Typography.Paragraph type="secondary">
        After activation, sign in to finish organization setup and billing inside WorkPlansIQ.
      </Typography.Paragraph>
    </section>
  );
}
